import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/language.service';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const languageService = inject(LanguageService);
  const lang = languageService.currentLanguage;

  if (req.headers.has('Accept-Language')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': lang,
      },
    }),
  );
};
